import {
  Injectable,
} from '@angular/core';
import {
  Order,
} from '@dapi/sdk';
import {
  upsertAndSelectEntityOrder,
} from '@des/store/order';
import {
  Actions,
  createEffect,
  ofType,
} from '@ngrx/effects';
import {
  Dictionary,
} from '@ngrx/entity';
import {
  Store,
} from '@ngrx/store';
import {
  SetAsyncStoreItemEntityActionPayload,
} from '@o3r/core';
import {
  AnalyticsSetSeats,
  AnalyticsSetServices,
  orderSeatItemsToProducts,
  orderServiceItemsToProducts,
} from '@refx/analytics-core';
import {
  CategoryConfiguration,
  extractCategoriesAnalyticsFriendlyNames,
  extractCategoryConfigurationMap,
  extractServicesAnalyticsFriendlyNames,
  SEAT_CATEGORY,
  ServiceConfiguration,
  ServiceRichContent,
} from '@refx/shared-common';
import {
  ServicesConfigurationService,
} from '@refx/shared-services';
import {
  CatalogServicesStore,
} from '@refx/shared-store';
import {
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';

@Injectable()
export class AnalyticsServicesEffect {
  public populateProductForSelfReacc$ = createEffect(() => this.actions$.pipe(
    ofType(
      upsertAndSelectEntityOrder
    ),
    withLatestFrom(
      this.servicesConfigurationService.serviceRichContents$,
      this.servicesConfigurationService.serviceDictionary$,
      this.servicesConfigurationService.categoryDictionary$
    ),
    switchMap(([action, servicesRichContent, serviceDictionary, categoryDictionary]:
    [SetAsyncStoreItemEntityActionPayload<Order>, ServiceRichContent[], Dictionary<ServiceConfiguration>, Dictionary<CategoryConfiguration>]) => {
      const categoryRichContentSeats = categoryDictionary[SEAT_CATEGORY]?.richContent;
      const categorySeatName = categoryRichContentSeats?.analyticsFriendlyName || '';
      const categoriesNames = extractCategoriesAnalyticsFriendlyNames(categoryDictionary);
      const servicesNames = extractServicesAnalyticsFriendlyNames(servicesRichContent);
      const categoryConfigurationMap = extractCategoryConfigurationMap(categoryDictionary);
      const order = action.entity;
      const selectedServicesIds = order.services?.filter((service) => !!service.id).map((service) => service.id) as string[];
      const selectedSeatIds = order.seats?.filter((seat) => !!seat.id).map((seat) => seat.id) as string[];
      const bounds = order.air?.bounds;
      const travelers = order.travelers;
      const products = orderServiceItemsToProducts(
        order.services || [],
        order.travelDocuments || [],
        bounds || [],
        categoriesNames,
        servicesNames,
        serviceDictionary,
        categoryConfigurationMap,
        selectedServicesIds || [],
        travelers || []
      );
      const seats = orderSeatItemsToProducts(
        order.seats || [],
        order.travelDocuments || [],
        bounds || [],
        SEAT_CATEGORY,
        categorySeatName,
        selectedSeatIds || [],
        travelers || []
      );
      return [AnalyticsSetServices({
        payload: products
      }), AnalyticsSetSeats({
        seats
      })];
    })
  ));

  constructor(
    protected actions$: Actions,
    protected store: Store<CatalogServicesStore>,
    private readonly servicesConfigurationService: ServicesConfigurationService
  ) {}
}
